import React, { useState } from "react";
import { notification, Spin } from "antd";
import environment from "environment";
import axios from "axios";
import OtpInput from "react-otp-input";
import RouteEnum from "constants/RouteEnum";
import closebutton from "../../../assets/images/close-btn.svg";
import featuredIcon from "../../../assets/images/Featured-icon.svg";
import CustomButton from "views/components/common/button/CustomButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const VerifyToken = ({ qrCodeUrl, user, toggleLoginForm }) => {
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState("");
    const { t } = useTranslation();
    const [close, setClose] = useState(false);
    const [optionClicked, setOptionClicked] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
    const handleVerifyToken = async (values) => {
        try {
            setOptionClicked(true);
            const response = await axios.post(
                `${environment.baseApi}/user/mfa`,
                { token: token, id: user },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.result.error) {
                notification.error({
                    message: t('loginError'),
                });
            } else {
                notification.success({
                    message: t('loginSuccess'),
                });
                if (rememberMe) {
                    localStorage.setItem(response.data.result.id, await generateEODtoken())
                }
                sessionStorage.setItem("authToken", response.data.result.token);
                navigate(RouteEnum.Extractpdf);
            }
        } catch (error) {
            console.error("Login failed", error);
        } finally {
            setLoading(false);
        }
    };
    const generateEODtoken = async () => {
        const currentDate = new Date();
        currentDate.setHours(23, 59, 59, 999);
        const EODTimestamp = currentDate.getTime()
        return EODTimestamp
    }
    const closePopup = () => {
        setClose(true);
        toggleLoginForm();
    };
    const isTokenValid = token.trim().length === 6;

    return (
        <Spin spinning={loading} tip="Loading..." size="large">
            {!close && (
                <div className="popup-background">
                    <div className="verify-otp-required">
                        <img
                            src={closebutton}
                            alt="close"
                            className="popup-close-btn"
                            onClick={closePopup}
                        />
                        <div className="modal-heading-icon">
                          <span className="modal-icon">
                            <img
                                src={featuredIcon}
                                alt="" className=""
                            />
                          </span>
                        </div>

                        <Spin spinning={loading} tip="Loading..." size="large">

                            {qrCodeUrl ? (
                                <>
                                    <p className="otpcode-detail mb-2">{t("verificationRequired")}</p>
                                    <p className="otpcode-subdetail mb-4">{t("verificationDescription")}</p>
                                </>

                            ) : (

                                <>
                                    <p className="otpcode-detail mb-2">{t("verificationRequired")}</p>
                                    <p className="otpcode-subdetail mb-4">{t("verificationDescription")}</p>
                                </>

                            )}
                        </Spin>
                        <div className="text-center">
                            {qrCodeUrl ? (
                                <>

                                    <img
                                        src={qrCodeUrl}
                                        alt="QR Code" className="my-4"
                                    />
                                    <OtpInput
                                        containerStyle="otpinput-container mb-3"
                                        value={token}
                                        onChange={setToken}
                                        numInputs={6}
                                        renderSeparator={<span></span>}
                                        renderInput={(props) => <input {...props} />}
                                        isDisabled={optionClicked}
                                        onClick={() => { setOptionClicked(true) }}
                                        skipDefaultStyles={true}
                                        shouldAutoFocus={false}
                                    />
                                    <div className="form-check d-flex">
                                      <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                      <label className="form-check-label cell-gray fs16 poppins-medium ml10" for="flexCheckDefault">
                                        {t("loginRemember")}
                                      </label>
                                    </div>
                                    <CustomButton
                                        label={t("Complete_login")}
                                        type="primary"
                                        htmlType="submit"
                                        className="btn-blue w-100 h38 br8 mt-md-4 mt-1"
                                        span_className="fs14 poppins-medium"
                                        onClick={handleVerifyToken}
                                        disabled={optionClicked}
                                    />
                                </>
                            ) : (
                                <>

                                    <OtpInput
                                        containerStyle="otpinput-container mb-3"
                                        value={token}
                                        onChange={setToken}
                                        numInputs={6}
                                        renderSeparator={<span></span>}
                                        renderInput={(props) => <input {...props} />}
                                        isDisabled={!optionClicked}
                                        onClick={() => { setOptionClicked(true) }}
                                        shouldAutoFocus={false}
                                    />
                                    <div className="form-check d-flex align-items-center mb-0">
                                      <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                      <label className="form-check-label body-gray fs16 poppins-medium ml10" for="flexCheckDefault">
                                        {t("loginRemember")}
                                      </label>
                                    </div>
                                    <CustomButton
                                        label={t("Complete_login")}
                                        type="primary"
                                        htmlType="submit"
                                        className="btn-blue h38 mt-md-4 mt-3 w-100 br8 mb-2 mb-md-auto"
                                        onClick={handleVerifyToken}
                                        disabled={!isTokenValid}
                                        span_className="fs14 poppins-medium"
                                    />
                                    <div className="d-flex justify-content-center mb-1">
                                     <a href="" className="link-text">{t("loginAppInfo")}</a>
                                    </div>
                                    {/*<div style={{ background: '#f2f2f2', padding: '10px', borderRadius: '5px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input type="checkbox" id="rememberMe" name="rememberMe" checked={rememberMe} onChange={handleCheckboxChange} style={{ marginRight: '5px' }} />
                                            <label htmlFor="rememberMe" style={{ fontSize: '18px', color: '#333', marginRight: '10px' }}>{t("remember")}</label>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: '13px', color: '#333', display: 'block', whiteSpace: 'break-spaces' }}>{t('rememberSentance')}</label>
                                        </div>
                                    </div>*/}
                                </>
                            )}
                        </div>
                    </div>
                </div>)}
        </Spin>
    );
};

export default VerifyToken;
